import React from 'react';
import styled from 'styled-components';
import Store from '../Common/Store';
import { FaTasks } from "react-icons/fa";
import { TiArrowBack } from "react-icons/ti";
import * as Style from './Common/StyledComponents';

class ReferrerHeader extends React.Component
{

	redirectTo = (event) => {
		event.preventDefault();
		window.location.assign(document.referrer);
	}

	render()
	{
		return (
			<Style.HeadContainer>
			    <Style.HomeLogo><FaTasks /></Style.HomeLogo>
			    <Style.HomeText>
			        <span style={{fontWeight: "600"}}>My Compliance Center / Task Manager / </span>
			        <span style={{fontWeight: "600", color: "#929292"}}>Committees & Governance</span>
			    </Style.HomeText>
			    <Style.Categories><span style={{cursor: "pointer", color: "#337ab7"}} onClick={this.redirectTo}><TiArrowBack /></span></Style.Categories>
			    <div style={{clear: "both"}}></div>
			</Style.HeadContainer>
		);
	}
}

export default ReferrerHeader;